<template>
  <div class="border border-zinc-200 dark:bg-zinc-800 dark:border-none rounded-lg">
    <div class="rounded-t-lg bg-zinc-200 dark:bg-zinc-700 px-4 py-2 flex justify-between items-center" v-if="title">
      <h5 class="font-medium text-lg" v-if="title">{{ title }}</h5>
      <slot name="info"></slot>
    </div>
    <div class="p-2">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: ""
  }
})
</script>